import { render, staticRenderFns } from "./Submit.vue?vue&type=template&id=773637c6"
import script from "./Submit.vue?vue&type=script&lang=ts"
export * from "./Submit.vue?vue&type=script&lang=ts"
import style0 from "./Submit.vue?vue&type=style&index=0&id=773637c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports